import { MaximizeIcon } from "@/components/icons";

export enum StrategyEnum {
  Maximize = "MaximizeResults",
  TargetCpc = "TargetCost",
}

export const options = [
  {
    title: 'Maximize results',
    desc: 'AhaCreator will aim to spend your entire budget and get the most conversions using the maximize results strategy.',
    icon: MaximizeIcon,
    value: StrategyEnum.Maximize,
  },
];

export const getBudgetOptions = () => {
  return [
    {
      label: "2,000",
      value: 2000,
    },
    {
      label: "3,000",
      value: 3000,
    },
    {
      label: "4,000",
      value: 4000,
    },
    {
      label: "5,000",
      value: 5000,
    },
    {
      label: "10,000",
      value: 10000,
    },
    {
      label: "20,000",
      value: 20000,
    },
    {
      label: "30,000",
      value: 30000,
    },
    {
      label: "50,000",
      value: 50000,
    },
    {
      label: "100,000",
      value: 100000,
    },
    {
      label: "200,000",
      value: 200000,
    },
    {
      label: "500,000",
      value: 500000,
    },
    {
      label: "1,000,000",
      value: 1000000,
    },
  ];
};

export const affiliateOptions = [
  {
    label: "250",
    value: 250,
  },
  {
    label: "500",
    value: 500,
  },
  {
    label: "1,000",
    value: 1000,
  },
  {
    label: "1,500",
    value: 1500,
  },
  {
    label: "2,000",
    value: 2000,
  },
  {
    label: "3,000",
    value: 3000,
  },
  {
    label: "4,000",
    value: 4000,
  },
  {
    label: "5,000",
    value: 5000,
  },
];

export const salesOptions = [
  {
    label: "250",
    value: 250,
  },
  {
    label: "500",
    value: 500,
  },
  {
    label: "1,000",
    value: 1000,
  },
  {
    label: "1,500",
    value: 1500,
  },
  {
    label: "2,000",
    value: 2000,
  },
  {
    label: "3,000",
    value: 3000,
  },
  {
    label: "4,000",
    value: 4000,
  },
  {
    label: "5,000",
    value: 5000,
  },
];

export enum expectedMaxCpmTypeEnum {
  AUTO = "auto",
  MANUAL = "manual",
}

export const expectedMaxCpmOptions = [
  {
    label: "Let AI agent set the CPM",
    value: expectedMaxCpmTypeEnum.AUTO,
    desc: "Let AI agent set the CPM for you. Good for brands that have no CPM limit",
    title: "Smart mode",
    showRecommend: true,
  },
  {
    label: "Set maximum CPM manually",
    value: expectedMaxCpmTypeEnum.MANUAL,
    desc: "Set maximum CPM cap manually. Good for brands that have strict CPM limit",
    title: "Manual mode",
  },
];

export enum orderPriceLimitSettingTypeEnum {
  AUTO = "auto",
  MANUAL = "manual",
}

export const budgetPerInfluencerOptions = [
  {
    label: "Let AI agent negotiate the price",
    value: orderPriceLimitSettingTypeEnum.AUTO,
    title: "Smart mode",
    desc: "Let AI agent negotiate the best price for you. Good for brands that have no budget limit for each influencer",
    showRecommend: true,
  },
  {
    label: "Set price limits manually",
    value: orderPriceLimitSettingTypeEnum.MANUAL,
    title: "Manual mode",
    desc: "Set the influencer budget manually. Good for brands that have strict budget limit",
  },
];

export enum RadioValueEnum {
  max = "max",
  min = "min",
}

export enum BudgetPerInfluencerTypeEnum {
  max = "Highest budget per influencer",
  min = "Lowest budget per influencer",
}

export const radioOptions = [
  { label: BudgetPerInfluencerTypeEnum.max, value: "max" },
  { label: BudgetPerInfluencerTypeEnum.min, value: "min" },
];

export const getEmailBody = (userName: string, businessName: string) => {
  return `
    Hi AhaCreator Team,
    I hope this message finds you well.
    
    My name is ${userName || '{your_name}'} , and I represent ${businessName} . 
    We are excited about the opportunity to launch a campaign on AhaCreator. However, we currently do not have a dedicated business email address.
    Could you please assist us by waiving the business email verification requirement? This would greatly help us get started with our campaign without delay.
    Thank you for your understanding and support.
    Best regards,
    
    ${userName || "{your_name}"}
    ${businessName}
  `;
};
